"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./revision.constants.js"), exports);
__exportStar(require("./revision.types.js"), exports);
__exportStar(require("./revision-version.js"), exports);
__exportStar(require("./revision-gating.js"), exports);
__exportStar(require("./revision-diff.js"), exports);
__exportStar(require("./revision-invalidation.js"), exports);
__exportStar(require("./revision-history.js"), exports);
__exportStar(require("./revision-review.js"), exports);
__exportStar(require("./revision-inclusion.js"), exports);
__exportStar(require("./revision-chat.js"), exports);
__exportStar(require("./revision-live-snapshot.js"), exports);
__exportStar(require("./revision-adjustment-code.js"), exports);
__exportStar(require("./revision-discount-allocation.js"), exports);
__exportStar(require("./revision-eligibility.js"), exports);
__exportStar(require("./revision-v1-map.js"), exports);
